import { atom } from "recoil";

// 選択した会場情報
export const selectedCourceVenueState = atom({
  key: "selectedCourceVenueState",
  default: {
    id: '',
    venue_id: null,
    name: null,
    prefecture_code: null,
    address: null,
  },
});